import { render } from "./ClassAdd.vue?vue&type=template&id=698ac834&scoped=true"
import script from "./ClassAdd.vue?vue&type=script&lang=js"
export * from "./ClassAdd.vue?vue&type=script&lang=js"

import "./ClassAdd.vue?vue&type=style&index=0&id=698ac834&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698ac834"]])

export default __exports__